export enum MessageTypes {
    Error = 'error',
    Success = 'success',
}
